export const globalSearchTransitionSpeedMs = 300;
export const globalSearchBorderRadiusPill = 50;
export const globalSearchInputMaxWidth = 480;
export const globalSearchInputCompactThreshold = 380;
